/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, bool, shape,
    string, number, arrayOf,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { decode as htmlDecode } from '../../../utils/htmlEntity';

const styles = (theme) => ({  // eslint-disable-line no-unused-vars
    subscriptionTitle: {
        fontSize: '16px',
    },
    subLabel: {
        fontSize: '14px',
        fontWeight: '700',
    },
    subAttr: {
        fontSize: '15px',
    },
});

function KeyboardArrowRight(props) {
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" /><path fill="none" d="M0 0h24v24H0V0z" />
        </svg>
    );
}

function SubscriptionSummary({ subscription, includeArrow, classes }) {
    return (
        <table width="100%">
            <tbody>
                <tr>
                    <td rowSpan="4" style={{ verticalAlign: 'top', width: '90px' }}>
                        <img alt="" src={subscription.productImageThumbnail} style={{ minWidth: '84px', maxWidth: '84px', marginRight: '10px' }} />
                    </td>
                    <td className={classes.subscriptionTitle}>
                        {htmlDecode(subscription.productName)}
                    </td>
                    { includeArrow
                        && (
                            <td rowSpan="4" style={{ verticalAlign: 'middle' }}>
                                <KeyboardArrowRight />
                            </td>
                        )}
                </tr>
                <tr>
                    <td>
                        <span className={classes.subLabel}>Item #: </span>
                        <span className={classes.subAttr}>{subscription.productId}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span className={classes.subLabel}>Price:  </span>
                        <span className={classes.subAttr}>${subscription.price}</span>
                    </td>
                </tr>
                { subscription.subscriptionStatus !== 'CANCELLED'
                    && (
                        <tr>
                            <td>
                                <span className={classes.subLabel}>Next Shipment: </span>
                                <span className={classes.subAttr}>{subscription.nextOrderDate}</span>
                            </td>
                        </tr>
                    )}
                { subscription.subscriptionStatus === 'CANCELLED'
                    && (
                        <tr>
                            <td>
                                <span className={classes.subLabel}>Cancelled</span>
                            </td>
                        </tr>
                    )}
            </tbody>
        </table>
    );
}

SubscriptionSummary.defaultProps = {
    includeArrow: false,
};

SubscriptionSummary.propTypes = {
    subscription: shape({
        checkoutBrand: string,
        duration: number.isRequired,
        endDate: string.isRequired,
        interval: number.isRequired,
        nextOrderDate: string,
        orderDate: string.isRequired,
        orderHistoryResult: arrayOf(
            shape({
                deliveryDate: string,
                discountAmount: string,
                orderDate: string.isRequired,
                orderNumber: string.isRequired,
                productCode: string.isRequired,
                productName: string.isRequired,
                productPrice: string.isRequired,
                quantity: string.isRequired,
            }),
        ),
        orderNumber: string.isRequired,
        orderTime: string.isRequired,
        orderType: string.isRequired,
        price: string.isRequired,
        productId: string.isRequired,
        productImageCategory: string.isRequired,
        productImageThumbnail: string.isRequired,
        productName: string.isRequired,
        quantity: string,
        recipient: arrayOf(shape({
            city: string.isRequired,
            country: string.isRequired,
            firstName: string.isRequired,
            lastName: string.isRequired,
            state: string.isRequired,
            street1: string.isRequired,
            street2: string.isRequired,
            zipcode: string.isRequired,
        })),
        ruleId: string.isRequired,
        startDate: string.isRequired,
        subscriptionStatus: string.isRequired,
        totalAmount: string.isRequired,
    }).isRequired,
    classes: object.isRequired,
    includeArrow: bool,
};

export default withStyles(styles, { withTheme: true })(SubscriptionSummary);
